import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-kpi-card',
  templateUrl: './app-kpi-card.component.html',
  styleUrls: ['./app-kpi-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppKpiCardComponent {
  /** Upper label text (e.g. 'NET SALES', 'NET RECEIVABLES') */
  @Input() label: string = '';

  /** Main metric value (formatted or raw number/string) */
  @Input() value: any = '';

  /** Whether to format numeric values with divide pipe */
  @Input() useDividePipe: boolean = true;

  /** Visual variant: 'default' | 'urgent' | 'primary' */
  @Input() variant: 'default' | 'urgent' | 'primary' = 'default';

  /** Quick boolean flag for urgent red styling */
  @Input() isUrgent: boolean = false;

  /** Subtitle/helper text */
  @Input() subtext: string = '';

  /** Optional percentage value (e.g. 96.5) */
  @Input() percentage: number | string | null = null;

  /** Label next to percentage (e.g. 'of total sales') */
  @Input() percentageLabel: string = '';

  /** Optional extra CSS class */
  @Input() cardClass: string = '';

  isNumeric(val: any): boolean {
    if (val === null || val === undefined || val === '') return false;
    return !isNaN(Number(val));
  }
}
